import { useNavigate } from "react-router-dom";
import { CustomButton, PageHeader } from "../../components";
import { popupNavigation } from "../../util/functions/UniversalFunctions";
import Calendar from "./Calendar";
import { IS_LIVE } from "../../util/config/env";

export default function CalendarAndEvent() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-3">
      <div className="flex justify-between items-center">
        <PageHeader title="CALENDAR & EVENTS" />
        <div className="flex gap-4">
          {!IS_LIVE && <CustomButton color="bg-success-500" text="Import" />}
          <CustomButton
            color="bg-primary-500"
            text="Create Event"
            onClick={() => navigate(popupNavigation("createEvent"))}
          />
        </div>
      </div>
      <div className="bg-white rounded-lg p-3 lg:px-7">
        <Calendar />
      </div>
    </div>
  );
}
